import React, { useEffect, useState } from 'react';
import { URL } from '../../Redux/common/url';

function Founder() {
  const [productLists, setProductLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/founderListPublic`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setProductLists(data?.founder || []);
      setLoading(false);
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  if (loading) return <p className="text-center py-5">Loading...</p>;

  return (
   <div className="container-fluid my-5 px-3 px-md-5">
  {productLists.map((item, index) => (
    <div
      className="row align-items-center mb-5"
      key={index}
    >
      {/* TEXT */}
      <div className="col-md-6 mb-4 mb-md-0">
        <h5
          style={{
            color: "#dc3545",
            fontWeight: "600",
            fontSize: "clamp(18px, 2vw, 26px)",
            marginBottom: "10px"
          }}
        >
          {item.title}
        </h5>

        <h1
          style={{
            fontWeight: "700",
            fontSize: "clamp(26px, 4vw, 42px)",
            lineHeight: "1.3"
          }}
        >
          {item.subheading}
        </h1>

        <p
          style={{
            fontSize: "clamp(14px, 1.5vw, 17px)",
            color: "#555",
            marginTop: "15px",
            lineHeight: "1.7"
          }}
        >
          {item.short_description}
        </p>
      </div>

      {/* IMAGE */}
      <div className="col-md-6 text-center">
        <img
          src={URL?.API_BASE_URL + item?.feature_image}
          alt={item.title}
          style={{
            width: "100%",
            maxWidth: "500px",
            height: "auto",
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
          }}
        />
      </div>
    </div>
  ))}
</div>
  );
}

export default Founder;